export default __webpack_public_path__ + "static/selo-77e62ea2c62cebf084cf1f382a55ee60.svg";